import * as React from 'react';
import { IBaseQuestionProps } from '../FormContainer/types/internal';
import { CardsQuestion } from '../../components/CardsQuestion';
import { useHandleSelect } from './utils/useHandleSelect';
import { QuestionLayoutContainer } from '../QuestionLayoutContainer';

export const CardsQuestionContainer: React.FC<React.PropsWithChildren<IBaseQuestionProps>> = props => {
  const {
    question: { answers, iconType, title, helpText },
  } = props;

  const handleSelect = useHandleSelect(props);

  if (!answers) {
    return null;
  }

  return (
    <QuestionLayoutContainer description={helpText?.text} title={title}>
      <CardsQuestion handleSelect={handleSelect} iconType={iconType} cards={answers} />
    </QuestionLayoutContainer>
  );
};

CardsQuestionContainer.displayName = 'CardsQuestionContainer';
